<template>
	<v-container grid-list-xl>		
		<v-form v-model="isAddValid">
			<v-layout row wrap>		
              <v-tabs slider-color="grey">
                <v-tab class="tab" :key="1" ripple>Details</v-tab>
                <v-tab class="tab" :key="2" ripple>Products</v-tab>                
                <v-tab-item class="pl-4 pr-4 pt-4 pb-4" :key="1">
                  <v-container grid-list-xl style="padding-top: 2% !important;">
                    <v-layout row wrap>
                      <v-flex lg6>
                        <label class="blackLabel">* Name:</label>
                        <v-text-field label="Package Name" :rules="nameRules" solo v-model="packageName" single-line required></v-text-field>
                      </v-flex>
                      <v-flex lg6>
                        <label class="blackLabel">* Short Name:</label>
                        <v-text-field label="Package Short Name" :rules="snameRules" solo v-model="packageShortName" single-line required></v-text-field>
                      </v-flex>
                      <v-flex lg12>
                        <label class="blackLabel">* Description:</label>
                        <v-text-field label="Package Description" :rules="descriptionRules" solo v-model="packageDescription" single-line required></v-text-field>
                      </v-flex>
                    </v-layout>
                  </v-container>
                </v-tab-item>
                <v-tab-item class="pl-4 pr-4 pt-4 pb-4" :key="2">
                  <v-container grid-list-xl style="padding-top: 2% !important;">
                    <v-layout row wrap> 
                      <v-flex lg12 style="padding-left: 0px;">
                        <div>
                          <v-btn color="success" class="text-xs-right" @click.stop="fncAddPackageProduct()">Add Product</v-btn>
                        </div>
                        </v-flex>
                        <br /><br />
                        <v-data-table :headers="headers" :items="objPackageAdd" class="elevation-1" hide-actions disable-initial-sort>
                          <template slot="items" slot-scope="props">
                            <td width="65%" class="text-xs-right"><v-select :items="objPackageAddProducts" label="Type" v-model="props.item.product_code" autocomplete solo item-value="id"></v-select></td>
                            <td width="25%" class="text-xs-right"><v-text-field :rules="nameRules" solo v-model="props.item.capacity" single-line required></v-text-field></td>
                            <td width="10%" class="text-xs-right"><a @click.prevent="fncDeletePackageProduct(props.item.product_code)"><i class="material-icons">delete_forever</i></a></td>
                          </template>
                        </v-data-table>
                      </v-layout>
                  </v-container>
                </v-tab-item>                
              </v-tabs>
				<div class="pl-4 pr-1 pb-2 pt-2 buttonHolder">
					<div style="float: right">
						<v-btn class="text-xs-right cancelButton" @click.stop="fncHideModal">Cancel</v-btn>
						<v-progress-circular indeterminate :width="3" :size="20" v-if="runAdd" color="grey" class="pt-3 loginLoader"></v-progress-circular>
						<v-btn color="success" class="text-xs-right" v-if="!runAdd" :disabled="!isAddValid" @click.stop="fncAddPackage()">Save</v-btn>
                      <small>* The button will activate once all required fields have been completed</small>
					</div>					
				</div>				
			</v-layout>
		</v-form>	
	</v-container>
</template>

<script>
	import { mapGetters } from 'vuex'; 	
	import Swatches from 'vue-swatches';
	import "vue-swatches/dist/vue-swatches.min.css";
	
	export default {
	  name: 'Settings',
	  components: { Swatches },
	  data () {
			return {
				runAdd: false,
				isAddValid: false,
                packageName: '',
                packageShortName: '',
                packageDescription: '',
                headers: [
                  { text: 'Product', value: 'pli_code', width: '65%' },
                  { text: 'Capacity (m2)', value: 'capacity', width: '25%' },
                  { text: 'Delete', value: 'delete', width: '10%' },
                ],
                headersAdd: [
                  { text: 'Product', value: 'pli_code' },
                  { text: 'Capacity (m2)', value: 'capacity' }
                ],
				nameRules: [
					v => !!v || 'Package name is required',				
				],
				descriptionRules: [
					v => !!v || 'Package description is required',				
				],
                snameRules: [
					v => !!v || 'Package short name is required',				
				]				
			};
		},		
		methods: {
			fncHideModal () {
				this.$store.commit('hideModal');
          },
            fncAddPackageProduct() {
              this.$store.commit('fncAddPackageProductNew');
            },
            fncDeletePackageProduct(prodCode) {
              this.$store.commit('fncRemovePackageProduct', prodCode)
            },
            fncAddPackage() {		
				this.runAdd = true;	
				this.$store.dispatch({
                  type: 'fncAddPackage',
                  name: this.packageName,                  
                  shortName: this.packageShortName,
                  description: this.packageDescription
                });			
                this.runAdd = false;	
			}
		},
		computed: {
			...mapGetters([			
				'objAuthorize',
                'globalModalParams',   
                'objPackageAdd',
                'objPackageAddProducts'
			])
		}
	}
</script>

<style scoped>
	/*@import '../../assets/css/shared.css'*/
</style>